import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFacetListComponent } from './facet-list.component';
import { I18nModule } from '@spartacus/core';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { CustomFacetModule } from '../facet/facet.module';
import { CustomActiveFacetsModule } from '../active-facets/active-facets.module';
import { ScreenViewModule } from '../../../../../../core/directives/screen-view/_screen-view.module';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    CustomFacetModule,
    KeyboardFocusModule,
    CustomActiveFacetsModule,
    ScreenViewModule,
  ],
  declarations: [CustomFacetListComponent],
  exports: [CustomFacetListComponent],
})
export class CustomFacetListModule {}
